export default __webpack_public_path__ + "img/7c1b7c6db6d8b59128bc8fbfeab24f32.svg";